import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { BoardMedium_URL } from "../../config";

// // fetch all mediums
// export const fetchMediums = createAsyncThunk(
//   'mediums/fetchMediums',
//   async () => {
//     const res = await axios.get(`${BoardMedium_URL}/all-mediums`)
//     return res.data.data
//   }
// )
export const fetchMediums = createAsyncThunk(
  "mediums/fetchMediums",
  async (board_id, { rejectWithValue }) => {
    try {
      const res = await axios.get(
        // `${BoardMedium_URL}/mediums-by-board/${board_id}`,
        `${BoardMedium_URL}/all-mediums/${board_id}`,
      );
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Something went wrong");
    }
  },
);

// create medium
export const createMedium = createAsyncThunk(
  "mediums/createMedium",
  async ({ name, description, boardId }) => {
    const res = await axios.post(`${BoardMedium_URL}/create-medium`, {
      name,
      description,
      created_by: 1,
      board_id: boardId,
    });
    return res.data;
  },
);

// update medium
export const updateMedium = createAsyncThunk(
  "mediums/updateMedium",
  async ({ id, name, description }) => {
    const res = await axios.put(`${BoardMedium_URL}/medium/${id}`, {
      name,
      description,
      updated_by: 1,
    });
    return res.data;
  },
);

// delete medium
export const deleteMedium = createAsyncThunk(
  "mediums/deleteMedium",
  async (id) => {
    await axios.delete(`${BoardMedium_URL}/${id}`);
    return id;
  },
);
// fetch all mediums
export const fetchAllMediums = createAsyncThunk(
  "mediums/fetchAllMediums",
  async (board_id, { rejectWithValue }) => {
    try {
      const res = await axios.get(`${BoardMedium_URL}/all-mediums/${board_id}`);
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Something went wrong");
    }
  },
);

// link / update mediums to board
export const linkMediumToBoard = createAsyncThunk(
  "mediums/linkMediumToBoard",
  async ({ board_id, medium_ids, created_by }) => {
    const res = await axios.post(`${BoardMedium_URL}/link-medium-board`, {
      board_id,
      medium_ids,
      created_by,
    });
    return res.data;
  },
);


const mediumSlice = createSlice({
  name: "mediums",
  initialState: { list: [], allList: [], status: "idle", loading: false },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch mediums
      .addCase(fetchMediums.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchMediums.fulfilled, (state, action) => {
        state.list = action.payload;
        state.loading = false;
      })
      .addCase(fetchMediums.rejected, (state) => {
        state.loading = false;
      })
      // Create medium
      .addCase(createMedium.pending, (state) => {
        state.loading = true;
      })
      .addCase(createMedium.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(createMedium.rejected, (state) => {
        state.loading = false;
      })
      // Update medium
      .addCase(updateMedium.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateMedium.fulfilled, (state, action) => {
        const idx = state.list.findIndex((m) => m.id === action.payload.id);
        if (idx !== -1) state.list[idx] = action.payload;
        state.loading = false;
      })
      .addCase(updateMedium.rejected, (state) => {
        state.loading = false;
      })
      // Delete medium
      .addCase(deleteMedium.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteMedium.fulfilled, (state, action) => {
        state.list = state.list.filter((m) => m.id !== action.payload);
        state.loading = false;
      })
      .addCase(deleteMedium.rejected, (state) => {
        state.loading = false;
      })
      // Fetch all mediums
      .addCase(fetchAllMediums.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAllMediums.fulfilled, (state, action) => {
        state.allList = action.payload;
        state.loading = false;
      })
      .addCase(fetchAllMediums.rejected, (state) => {
        state.loading = false;
      })
      // Link medium to board
      .addCase(linkMediumToBoard.pending, (state) => {
        state.loading = true;
        state.status = "loading";
      })
      .addCase(linkMediumToBoard.fulfilled, (state) => {
        state.loading = false;
        state.status = "succeeded";
      })
      .addCase(linkMediumToBoard.rejected, (state) => {
        state.loading = false;
        state.status = "failed";
      });
  },
});

export default mediumSlice.reducer;
